import { gql } from '@apollo/client';

export const ZIP_BY_ID = gql`
  query GEO_SERVICE_zipById($id: String!) {
    zipById(id: $id) {
      id
      state {
        id
        name
      }
      counties {
        id
        name
      }
    }
  }
`;
